/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { transaction, observable } from 'mobx';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';

class SelectedManager {
    @observable _selectedArray: Array<any> = [];

    get length() {
        return this.selectedArray.length;
    }

    get selectedArray() {
        return this._selectedArray;
    }

    public add(...items) {
        transaction(() => {
            items.forEach((item) => {
                if (item && this._findItem(item) === false) {
                    item.selected = true;
                    this.selectedArray.push(item);
                }
            });
        });
    }

    public remove(...items) {
        transaction(() => {
            items.forEach((item) => {
                item.selected = false;
                const index = this.selectedArray.indexOf(item);
                if (index !== -1) {
                    this.selectedArray.splice(index, 1);
                }
            });
        });
    }

    public objectAtIndex(index) {
        return this.selectedArray[index];
    }

    public indexOfObject(item) {
        if (item) {
            return this.selectedArray.indexOf(item);
        }
        return -1;
    }


    public clear() {
        transaction(() => {
            this.selectedArray.forEach((item) => {
                item.selected = false;
            });
            this.selectedArray.splice(0, this.selectedArray.length);
        });
    }

    clearAndAdd(...items) {
        transaction(() => {
            this.selectedArray.forEach((item) => {
                item.selected = false;
            });
            this.selectedArray.splice(0, this.selectedArray.length);

            items.forEach((item) => {
                item.selected = true;
                this.selectedArray.push(item);
            });
        });
    }

    /**
     *  返回 将selectedArray 按照 slide或group 顺序排序。
     * @param slideOrGroup
     * @param selectedArray
     * @returns {
     */
    public sortSelectedArray(slideOrGroup, selectedArray) {
        const sortArray = [] as Array<any>;
        if (selectedArray.some(i => i.isMaster)) {
            // 暂不支持选择的元素包含母版的情况
            return sortArray;
        }
        const isSelectedLayout = selectedArray.length && selectedArray.every(i => i.isLayout);
        // 当选择的元素是 layout 时，从 layoutList 获取元素
        // 当选择的元素是 slide、element 等时，从 children 获取元素
        const slideOrGroupChildren = isSelectedLayout ? slideOrGroup.layoutList : slideOrGroup.children;
        for (let i = 0; i < slideOrGroupChildren.length; i++) {
            const tempI = slideOrGroupChildren[i];
            for (let j = 0; j < selectedArray.length; j++) {
                const tempJ = selectedArray[j];
                if (tempI === tempJ) {
                    sortArray.push(tempJ);
                    break;
                }
            }
        }
        return sortArray;
    }


    // Private Methods

    private _findItem(item) {
        return this._selectedArray.indexOf(item) !== -1;
    }
}


export default SelectedManager;
